export default __webpack_public_path__ + "static/heart-d999d8370ca7edb57b9ab2448d6be742.svg";